import React, { useState } from 'react'
import { Text, View, StyleSheet, Image, TextInput, Pressable } from 'react-native'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import NetInfo from '@react-native-community/netinfo'
import { SelectList } from 'react-native-dropdown-select-list'
import { apiUrl } from '../../config/config'
import { useSelector } from 'react-redux'
import { getConection } from '../appBar/context/HeaderContext'
import styles from './ProfileContactStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import {
    SendContact,
    getDeviceInfo,
    getStorageAvailable,
    validateConnectionNetwork,
} from '../../utils/functions.utils'
import { UserServices } from '../../../database/user.database'
import { ErrorServices } from '../../../database/errors.database'
import { schedulesServices } from '../../../database/schedules.database'
import { SCHEDULES_STORE_NAMES } from '../../db/posSchedules'
import { FORM_SCHEDULE_STATUS } from '../stores/constants/constants.stores'
import { getLocation } from '../appBar/context/LocationContext'
import { getAlert } from '../appBar/context/AlertsContext'
import { Loader } from '../customUtils/Components/Loader'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
export const ProfileContact = ({ closeBottomShet }) => {
    const { setAlert } = getAlert()
    const { languageFile } = getLanguage()
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
    const [selectedChannel, setChannel] = useState('')
    const apiEndpoint = `${apiUrl}/send_contact`
    const { isConnected } = getConection()
    const { userLat, userLng } = getLocation()
    //const token = useSelector((state) => state.auth.authToken)
    const [sentContact, setSent] = useState(false)
    const [loadingSendContact, setLoadingSendContact] = useState(false)
    const { closeBottomSheet } = useBottomSheet()

    const onChangeSubject = (value) => {
        setSubject(value)
    }
    const onChangeMessage = (value) => {
        setMessage(value)
    }
    const dropdownArray = ['App', 'Soporte', 'Otro']

    const sendContactProfile = async (subject, message, selectedChannel) => {
        try {
            setLoadingSendContact(true)
            const hasConnection = await validateConnectionNetwork()
            if (!hasConnection) {
                setTimeout(() => {
                    closeBottomSheet(true)
                    setAlert(
                        'No puedes realizar esta acción sin conexión a internet',
                        'white',
                        'wifi-off',
                        'rgba(0, 0, 0, 0.8)',
                    )
                }, 1500)

                return
            }

            if (
                subject.trim() == '' ||
                message.trim() == '' ||
                selectedChannel.trim() == ''
            ) {
                setLoadingSendContact(false)
                return
            }
            let send = await SendContact(
                subject,
                message,
                selectedChannel,
                userLat,
                userLng,
            )
            if (send) {
                setLoadingSendContact(false)
                setSent(true)
                setSubject('')
                setMessage('')
            }
        } catch (error) {
            console.error('sendContactProfile ~ error:', error)
        } finally {
            setTimeout(() => {
                setLoadingSendContact(false)
            }, 1500)
        }
    }

    return (
        <>
            {!sentContact ? (
                <View style={{ flex: 1 }}>
                    <View style={styles.container}>
                        <Text style={styles.tagInput}>
                            {languageFile.contact_channel}
                        </Text>

                        <SelectList
                            placeholder={languageFile.select_the_contact_channel}
                            data={dropdownArray}
                            setSelected={(val) => setChannel(val)}
                            save='value'
                            search={false}
                            arrowicon={
                                <Feather
                                    name={'chevron-down'}
                                    size={22}
                                    color={theme.colors.colorPrimary}
                                />
                            }
                            boxStyles={[styles.input, { paddingVertical: 0 }]}
                            dropdownStyles={styles.dropdown}
                            dropdownTextStyles={styles.dropdownOptions}
                            inputStyles={styles.dropdownInput}
                        />

                        <Text style={styles.tagInput}>{languageFile.subject}</Text>
                        <TextInput
                            style={styles.input}
                            onChangeText={onChangeSubject}
                            value={subject}
                            placeholder={languageFile.write_the_subject}
                            placeholderTextColor={theme.colors.inputPlaceholder}
                        />

                        <Text style={styles.tagInput}>{languageFile.message}</Text>
                        <TextInput
                            style={styles.input}
                            onChangeText={onChangeMessage}
                            value={message}
                            height={100}
                            multiline={true}
                            placeholder={languageFile.write_a_comment}
                            placeholderTextColor={theme.colors.inputPlaceholder}
                        />
                    </View>
                    <View style={styles.buttonContainer}>
                        {loadingSendContact ? (
                            <Loader />
                        ) : (
                            <Pressable
                                onPress={() =>
                                    sendContactProfile(
                                        subject,
                                        message,
                                        selectedChannel,
                                    )
                                }
                                style={styles.mainButton}
                            >
                                <Text style={styles.mainButtonText}>
                                    {languageFile.send}
                                </Text>
                            </Pressable>
                        )}
                    </View>
                </View>
            ) : (
                <>
                    <View style={styles.containerFeedback}>
                        <Image
                            style={styles.image}
                            source={require('../../../assets/sentSuccessfully.png')}
                        />
                        <Text style={styles.title}>
                            {languageFile.sent_successfully}
                        </Text>
                        <Text style={styles.description}>
                            {languageFile.thank_you_for_leaving_us_your_comments}
                        </Text>
                    </View>

                    <View style={styles.buttonContainer}>
                        <Pressable
                            onPress={() => closeBottomShet(true)}
                            style={styles.mainButton}
                        >
                            <Text style={styles.mainButtonText}>
                                {languageFile.close}
                            </Text>
                        </Pressable>
                    </View>
                </>
            )}
        </>
    )
}
